<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wIab9i/tc-custom/9780300235265.jpg?1709153016912" alt="This image is the cover for the book Blueprint for War, The Henry L. Stimson Lectures Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blueprint for War, The Henry L. Stimson Lectures Series
      </h1>
      <p class="bookDescription body article font2">
        <p>“<b>Dunn shows how FDR’s Third Hundred Days were critical to overcoming isolationism and rebuilding American leadership in an age of global turmoil.” (E.J. Dionne Jr., <i>New York Times </i>bestselling co-author of <i>One Nation After Trump</i>)</b><br/>  <br/> In the cold winter months that followed Franklin Roosevelt’s election in November 1940 to an unprecedented third term in the White House, he confronted a worldwide military and moral catastrophe. Almost all the European democracies had fallen under the ruthless onslaught of the Nazi army and air force. Great Britain stood alone, a fragile bastion between Germany and American immersion in war. In the Pacific world, Japan had extended its tentacles deeper into China. Susan Dunn dramatically brings to life the most vital and transformational period of Roosevelt’s presidency: the hundred days between December 1940 and March 1941, when he mobilized American industry, mustered the American people, initiated the crucial programs and approved the strategic plans for America’s leadership in World War II. As the nation began its transition into the preeminent military, industrial, and moral power on the planet, FDR laid out the stunning blueprint not only for war but for the American Century.<br/>  <br/> “Dunn’s achievement is to make the view of FDR’s accomplishment clear.” —<i>The Boston Globe</i><br/>  <br/> “Susan Dunn is one of the great Roosevelt historians of our time.” —Michael Beschloss, <i>New York Times </i>bestselling author of <i>Presidents of War</i><br/>  <br/> “Superbly researched and written.” —James T. Patterson, Bancroft Prize-winning author of <i>Grand Expectations</i><br/>  <br/> “The definitive telling of a pivotal episode in American history.” —Edward J. Larson, Pulitzer Prize-winning author of <i>The Return of George Washington</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Dunn
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b72f8542